export var editUPIMapper = function (response) {
    var result = {
        requestid: "",
        success: false,
        message: "",
        statuscode: "",
        errors: "",
        data: "",
    };
    if (response) {
        result = response;
    }
    return result;
};
